import { jwtDecode } from "jwt-decode";

export const auth = {
    namespaced: true,
    state: {
        userData: JSON.parse(localStorage.getItem("userData")),
        accessToken: localStorage.getItem("accessToken"),
        decodedToken: null,
        userRoles: [],
    },

    mutations: {
        authUser(state, item) {
            state.userData = item.userData;
            state.accessToken = item.accessToken;

            // Decode JWT token and extract roles
            if (item.accessToken) {
                try {
                    state.decodedToken = jwtDecode(item.accessToken);

                    // Get roles from JWT token (stored in 'role' property as array)
                    state.userRoles = state.decodedToken.role || [];

                    console.log(
                        "JWT decoded successfully. User roles:",
                        state.userRoles
                    );
                } catch (error) {
                    console.error("Error decoding JWT token in store:", error);
                    state.decodedToken = null;

                    // Fallback: try to get roles from userData
                    state.userRoles =
                        item.userData?.userData?.roles ||
                        item.userData?.roles ||
                        [];
                    console.log(
                        "Using fallback roles from userData:",
                        state.userRoles
                    );
                }
            }
        },

        updateToken(state, token) {
            state.accessToken = token;
            localStorage.setItem("accessToken", token);

            // Decode new token
            if (token) {
                try {
                    state.decodedToken = jwtDecode(token);
                    state.userRoles = state.decodedToken.role || [];
                } catch (error) {
                    console.error("Error decoding JWT token:", error);
                    state.decodedToken = null;
                    state.userRoles = [];
                }
            }
        },

        logout(state) {
            localStorage.removeItem("accessToken");
            localStorage.removeItem("userData");
            localStorage.removeItem("unvInfo");
            localStorage.removeItem("dark_theme");
            localStorage.removeItem("userTraining-1");
            state.accessToken = null;
            state.userData = null;
            state.decodedToken = null;
            state.userRoles = [];
            localStorage.clear();
        },
    },

    getters: {
        isAuthenticated: (state) => !!state.accessToken,
        userRoles: (state) => state.userRoles,
        hasRole: (state) => (role) => {
            if (Array.isArray(role)) {
                return role.some((r) => state.userRoles.includes(r));
            }
            return state.userRoles.includes(role);
        },
        isTokenExpired: (state) => {
            if (!state.decodedToken) return true;
            const currentTime = Date.now() / 1000;
            return (
                state.decodedToken.exp && state.decodedToken.exp < currentTime
            );
        },
    },

    actions: {
        login({ commit }, userData = null) {
            const storedUserData =
                userData || JSON.parse(localStorage.getItem("userData"));
            const storedToken = localStorage.getItem("accessToken");

            if (storedUserData && storedToken) {
                commit("authUser", {
                    userData: storedUserData,
                    accessToken: storedToken,
                });
            }
        },

        refreshToken({ commit }, token) {
            commit("updateToken", token);
        },

        logout({ commit }) {
            commit("logout");
        },
    },
};
